import styled from "@emotion/styled";
import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import {
  ColDef,
  ICellRendererParams,
  SelectionChangedEvent,
} from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import { useFormik } from "formik";
import { useContext, useEffect, useRef, useState } from "react";
import { customTheme } from "../../../../config/theme/MuiTheme";
import { GlobalContext } from "../../../../util/state/GlobalContextProvider";
import { setSnackbar } from "../../../../util/state/globalAction";
import { snackbarTypes } from "../../../../util/state/globalVariables";
import AgGridCustomTable from "../../../../util/component/AgGridCustomTable";
import { useAgGridCustomDatasource } from "../../hooks/useAgGridCustomDatasource";
import AutoComplete, { AutoCompleteOption } from "../common/AutoComplete";
// import AutoComplete from "../common/AutoComplete";
import EmptyStateGrid from "../common/EmptyStateGrid";
import GenericFilterBox from "../common/GenericFilterBox";
import MonySymbolsComponets from "../common/MonySymbolsComponents";
import { nameof } from "../common/ObjectUtils";
import { getAllClass, getAllPart, getAllWinityCodes } from "./ManipulateValues";
import { DamageTypes } from "./Types";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import AddIcon from "@mui/icons-material/Add";
import EditDamagePriceList from "./EditDamagePriceList";
import useToggle from "../../hooks/useToggle";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import CreateDamagePriceList from "./CreateDamagePriceList";
import FileSaver from "file-saver";
import useSnackbar from "../../hooks/useSnackbar";
import Loading from "../../../finance/component/Loading";
import DamageService from "./service/damage.action";
import { ContextOperation } from "../../context/OperationContext";
import useTenant from "../../hooks/useTenant";
import React from "react";
import "./damagePrice.css";
import { Box, Tooltip } from "@mui/material";
import { Parser } from "../../utils";
import { useHasScope } from "../../../../config/globalConfig";
import AgGridOperationTable from "../common/AgGridOperationTable";

const StyledActionsBox = styled(Mui.Box)({
  backgroundColor: customTheme.palette.neutral.bright,
});

export const DamagePriceTable = (props: any) => {
  const hasScope = useHasScope;
  const gridEquipmentKitsRef = useRef<AgGridReact>(null);
  const gridEquipmentsRef = useRef<AgGridReact>(null);
  const t = useOperationTranslation();
  const [listCarClass, setListCarClass] = useState<AutoCompleteOption[]>([]);
  const [listPart, setListPart] = useState<any>([]);
  const [winityCode, setWinityCode] = useState<any>([]);
  const [showEdit, toggleEdit] = useToggle();
  const [showCreate, toggleCreate] = useToggle();
  const [dangerPriveList, setDamagePriveList] = useState<
    DamageTypes.Damage | undefined
  >(undefined);
  const [idForDelete, setIdForDelete] = useState<any>({});
  const { setLoading } = useContext(ContextOperation);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const { tenant } = useContext(ContextOperation);
  const { dispatchGlobalData } = useContext(GlobalContext);
  const [open, setOpen] = React.useState(false);
  const onClickCloseDialog = () => setOpen(false);
  const [refreshTableByDelete, setRefreshTableByDelete] = useState(false);
  const formik = useFormik<DamageTypes.FilterDamage>({
    initialValues: {},
    onSubmit: () => {},
  });
  const [
    damagePriceListDataSource,
    totalEquipmentKits,
    updateDatasourceDamage,
  ] = useAgGridCustomDatasource(
    DamageService.get.getAll,
    [tenant, formik.values],
    [tenant, formik.submitCount]
  );
  const snackbar = useSnackbar();

  useEffect(() => {
    gridEquipmentKitsRef.current?.api.deselectAll();
  }, [formik.submitCount]);

  useEffect(() => {


    formik.resetForm();
    getAllClass(tenant).then((response: any) => setListCarClass(response));

    getAllPart(tenant).then((response) => {
      setListPart(response);
    });
    getAllWinityCodes(tenant).then((response: any) => {
      setWinityCode(response);
    });


  }, [tenant]);
  const openEditModal = (params: DamageTypes.Damage | undefined) => {
    setDamagePriveList(params);
    toggleEdit();
  };

  const handleDownloadTemplate = () => {
    setLoading(true);
    DamageService.get
      .downloadTemplate(tenant)
      .then((response) => {
        const filename =
          response.headers["content-disposition"].split("filename=")[1];
        var blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        FileSaver.saveAs(blob, filename);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
        snackbar.show(
          "error",
          t("vehicleEquipment.modifyEquipment.actionError")
        );
      });
  };

  const onImageChange = (event: any) => {
    setLoading(true);
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      const formData = new FormData();
      formData.append("file", img);
      if (img) {
        DamageService.put
          .uploadTemplate(formData, tenant)
          .then((response) => {
            setLoading(false);
            snackbar.show("success", t("dangerPrice.messages.uploadMessages"));
            updateDatasourceDamage();
          })
          .catch(() => {
            // setLoading(true);
            snackbar.show(
              "error",
              t("dangerPrice.messages.errorUploadMessage")
            );
            setLoading(false);
          });
      }
      event.target.value = null;
    }
  };

  const handleDownloadExcel = () => {
    setLoading(true);
    DamageService.get.exportExel(formik.values, tenant).then((response) => {
      const filename =
        response.headers["content-disposition"].split("filename=")[1];
      var blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(blob, filename);
      setLoading(false);
    });
  };

  const isDisabled = () => {
    if (Object.keys(formik?.values).length !== 0) {
      return Object.values(formik?.values).every((x) => x === null || x === "");
    }
    return true;
  };

  const deleteSelectedPrice = (id: any) => {
    setLoading(true);
    DamageService.delete
      .delete(id, tenant)
      .then(() => {
        dispatchGlobalData({
          type: setSnackbar,
          payload: {
            snackbar: {
              message: t(
                "dangerPrice.dialogs.delete.deleteActionSuccessMessage"
              ),
              type: snackbarTypes.success,
              show: true,
              autoClose: true,
            },
          },
        });
        setLoading(false);
        updateDatasourceDamage();
        //setRefreshTableByDelete(!refreshTableByDelete);
      })

      .catch((error: any) => {
        if (error.response.status == 404) {
          snackbar.show("error", t("dangerPrice.messages.delete404Error"));
        } else if (error.response.status == 409) {
          snackbar.show("error", t("dangerPrice.messages.delete409Error"));
        } else {
          snackbar.show("error", t("dangerPrice.messages.genericDeleteError"));
        }
        setLoading(false);
      });
  };

  const onClickDelete = () => {
    setOpen(false);
    deleteSelectedPrice(idForDelete);
  };

  const dangerColumns: ColDef[] = [
    {
      field: nameof<DamageTypes.Damage>("carClass"),
      headerName: t("dangerPrice.fields.carClass"),
      flex: 0.8,
    },
    {
      field: nameof<DamageTypes.Damage>("part"),
      headerName: t("dangerPrice.fields.part"),
      flex: 0.7,
      cellRenderer: (props: ICellRendererParams<DamageTypes.Damage>) => {
        return (
          <Tooltip
            title={
              <>
                {props.data?.part?.descr} {props.data?.position?.descr!}
              </>
            }
          >
            <span>
              {
                <>
                  {props.data?.part?.descr} {props.data?.position?.descr!}
                </>
              }
            </span>
          </Tooltip>
        );
      },
    },
    {
      field: nameof<DamageTypes.Damage>("substitionPrice"),
      headerName: t("dangerPrice.fields.substitution"),
      flex: 1,
      cellRenderer: (props: ICellRendererParams<DamageTypes.Damage>) => {
        return (
          <MonySymbolsComponets
            symbolText={Parser.price(props.data?.substitionPrice)}
            symbols={props.data?.currency}
          />
        );
      },
    },
    {
      field: nameof<DamageTypes.Damage>("lightPrice"),
      headerName: t("dangerPrice.fields.damage"),
      flex: 1,
      cellRenderer: (props: ICellRendererParams<DamageTypes.Damage>) => {
        return (
          <MonySymbolsComponets
            symbolText={Parser.price(props.data?.lightPrice)}
            symbols={props.data?.currency}
          />
        );
      },
    },
    {
      field: nameof<DamageTypes.Damage>("mediumPrice"),
      headerName: t("dangerPrice.fields.medium"),
      flex: 1.1,
      cellRenderer: (props: ICellRendererParams<DamageTypes.Damage>) => {
        return (
          <MonySymbolsComponets
            symbolText={Parser.price(props.data?.mediumPrice)}
            symbols={props.data?.currency}
          />
        );
      },
    },

    {
      field: nameof<DamageTypes.Damage>("heavyPrice"),
      headerName: t("dangerPrice.fields.heavy"),
      flex: 1,
      cellRenderer: (props: ICellRendererParams<DamageTypes.Damage>) => {
        return (
          <MonySymbolsComponets
            symbolText={Parser.price(props.data?.heavyPrice)}
            symbols={props.data?.currency}
          />
        );
      },
    },
    {
      field: nameof<DamageTypes.Damage>("paintExtraTime"),
      headerName: t("dangerPrice.fields.paint"),
      flex: 1,
      cellRenderer: (props: ICellRendererParams<DamageTypes.Damage>) => {
        return (
          <Mui.Chip
            label={props.data?.paintExtraTime ? "True" : "False"}
            sx={{
              backgroundColor: !props.data?.paintExtraTime
                ? "rgba(213, 43, 30, 0.2)"
                : "rgba(0, 168, 120, 0.3)",
            }}
          />
        );
      },
    },
    {
      field: nameof<DamageTypes.Damage>("winityCodeVehicle"),
      headerName: t("dangerPrice.fields.winity"),
      flex: 0.8,
    },

    {
      //maxWidth: 50,
      flex: 0.5,
      cellStyle: {
        padding: "0px",
        border: "none",
      },
      cellRenderer: (props: ICellRendererParams<DamageTypes.Damage>) => {
        const onClick = () => {
          setOpen(true);
          setIdForDelete(props.data?.id);
        };
        return (
          <StyledActionsBox>
            {hasScope("SCOPE_UPDATE_DAMAGE_PRICE") && (
              <Mui.Tooltip title={t("tooltipTitle.edit")}>
                <Mui.IconButton color="accent">
                  <MuiIcons.Edit onClick={() => openEditModal(props.data)} />
                </Mui.IconButton>
              </Mui.Tooltip>
            )}
            {hasScope("SCOPE_DELETE_DAMAGE_PRICE") && (
              <Tooltip title={t("tooltipTitle.delete")}>
                <Mui.IconButton color="accent" onClick={onClick}>
                  <MuiIcons.Delete />
                </Mui.IconButton>
              </Tooltip>
            )}
          </StyledActionsBox>
        );
      },
    },
  ];

  return (
    <Mui.Box>
      {showCreate === false ? (
        <>
          <form
            id="equipment-kit-tab-search-form"
            onSubmit={formik.handleSubmit}
          >
            <GenericFilterBox
              formId="equipment-kit-tab-search-form"
              onReset={() => formik.resetForm()}
              disableResetButton={isDisabled()}
            >
              <AutoComplete
                options={listCarClass}
                label={t("dangerPrice.fields.carClass")}
                value={formik.values.carClass || ""}
                onChange={(value) => {
                  formik.setFieldValue(
                    nameof<DamageTypes.FilterDamage>("carClass"),
                    value
                  );
                }}
                fullWidth
              />

              <AutoComplete
                options={listPart}
                label={t("dangerPrice.fields.part")}
                onChange={(value) => {
                  formik.setFieldValue(
                    nameof<DamageTypes.FilterDamage>("part"),
                    value
                  );
                }}
                value={formik.values.part || ""}
                fullWidth
              />

              <AutoComplete
                options={winityCode}
                label={t("dangerPrice.fields.winity")}
                value={formik.values?.winity || ""}
                onChange={(value) =>
                  formik.setFieldValue(
                    nameof<DamageTypes.FilterDamage>("winity"),
                    value
                  )
                }
                fullWidth
              />
            </GenericFilterBox>
          </form>

          <Mui.Card>
            <Mui.CardContent>
              <Mui.Box
                sx={{
                  backgroundColor: "white",
                  border: " 1px solid #dbe4e9",
                  borderRadius: "2px",
                  padding: "9px 1px 3px 2px",
                }}
              >
                <Mui.Grid
                  container
                  spacing={2}
                  alignItems="center"
                  alignContent="center"
                  direction="row"
                >
                  <Mui.Grid item xs={6}></Mui.Grid>
                  <Mui.Grid item xs={6}>
                    <Mui.Box
                      sx={{
                        justifyContent: "flex-end",
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      {(hasScope("SCOPE_CREATE_DAMAGE_PRICE") ||
                        hasScope("SCOPE_UPDATE_DAMAGE_PRICE") ||
                        hasScope("SCOPE_DELETE_DAMAGE_PRICE")) && (
                        <>
                          <Mui.Button
                            startIcon={<FileDownloadIcon />}
                            className="filtersBtn uploadDownloadBtns"
                            variant="outlined"
                            onClick={handleDownloadTemplate}
                          >
                            <Mui.Typography color={"accent"} fontWeight={700}>
                              {t("dangerPrice.downloadTemplate")}
                            </Mui.Typography>
                          </Mui.Button>

                          <Mui.Box className="App">
                            <label htmlFor="upload-equipment">
                              <input
                                style={{ display: "none" }}
                                id="upload-equipment"
                                onChange={onImageChange}
                                name="upload-equipment"
                                type="file"
                              />
                              <Mui.Button
                                aria-label="toggle filter"
                                startIcon={<FileUploadIcon />}
                                component="span"
                                variant="contained"
                                className="filtersBtn uploadDownloadBtns"
                              >
                                <Mui.Typography
                                  color={"accent"}
                                  fontWeight={700}
                                >
                                  {t("dangerPrice.uploadPriceList")}
                                </Mui.Typography>
                              </Mui.Button>
                            </label>
                          </Mui.Box>
                        </>
                      )}

                      <Mui.Stack direction="row" alignItems="center">
                        <Mui.IconButton
                          disabled={totalEquipmentKits ? false : true}
                          onClick={handleDownloadExcel}
                          color="accent"
                        >
                          <Mui.Tooltip title={t("tooltipTitle.download")}>
                            <FileDownloadIcon />
                          </Mui.Tooltip>
                        </Mui.IconButton>
                        {hasScope("SCOPE_CREATE_DAMAGE_PRICE") && (
                          <Mui.IconButton color="accent">
                            <Mui.Tooltip title={t("tooltipTitle.add")}>
                              <AddIcon onClick={() => toggleCreate()} />
                            </Mui.Tooltip>
                          </Mui.IconButton>
                        )}
                      </Mui.Stack>
                    </Mui.Box>
                  </Mui.Grid>
                </Mui.Grid>
              </Mui.Box>

              <Mui.Grid>
                <Mui.Grid item sx={{ whiteSpace: "pre-wrap" }}>
                   <AgGridOperationTable
                    gridRef={gridEquipmentsRef}
                    columnDefs={dangerColumns}
                    serverSideDatasource={damagePriceListDataSource}
                    rowModelType="serverSide"
                    serverSideInfiniteScroll={true}
                    cacheBlockSize={10}
                    rowSelection="single"
                    totalElements={totalEquipmentKits}
                    emptyState={{
                      title: t("dangerPrice.pageTitles.noDangerTitle"),
                      content: t("dangerPrice.pageTitles.noDangerText")
                    }}
                  />

                </Mui.Grid>
              </Mui.Grid>
            </Mui.CardContent>
          </Mui.Card>
        </>
      ) : (
        <CreateDamagePriceList
          onClose={toggleCreate}
          onReset={() => formik.resetForm()}
          updateDatasourceDamage={updateDatasourceDamage}
          formikValues={formik.values}
          open={showCreate}
        />
      )}

      <EditDamagePriceList
        open={showEdit}
        onClose={toggleEdit}
        onReset={() => formik.resetForm()}
        updateDatasourceDamage={updateDatasourceDamage}
        formikValues={formik.values}
        dangerPriveList={dangerPriveList}
      />

      <Mui.Dialog
        open={open}
        PaperProps={{
          sx: {
            minWidth: "600px !important",
            minHeight: "194px",
            borderRadius: "4px",
          },
        }}
      >
        <Mui.DialogTitle>
          <Mui.Grid
            container
            alignItems="center"
            alignContent="center"
            direction="row"
          >
            <Mui.Grid xs item>
              <Mui.Stack direction="row" alignItems="center" gap={1}>
                <MuiIcons.Info sx={{ color: "#C8017D" }} fontSize="small" />
                <Box>{t("dangerPrice.dialogs.delete.title")}</Box>
              </Mui.Stack>
            </Mui.Grid>
            <Mui.Grid
              xs
              item
              sx={{
                justifyContent: "flex-end",
                display: "flex",
              }}
            >
              <MuiIcons.Close
                color="disabled"
                fontSize="small"
                onClick={onClickCloseDialog}
              />
            </Mui.Grid>
          </Mui.Grid>
        </Mui.DialogTitle>

        <Mui.DialogContent>
          <Mui.DialogContentText>
            {t("dangerPrice.dialogs.delete.bodyMessage")}
          </Mui.DialogContentText>
        </Mui.DialogContent>
        <Mui.DialogActions>
          <Mui.Stack direction="row" spacing={2} p={1} mr={1}>
            <Mui.Button
              sx={{
                maxWidth: "111px",
                maxHeight: "48px",
                minWidth: "111px",
                minHeight: "48px",
              }}
              variant="outlined"
              onClick={onClickCloseDialog}
            >
              <Mui.Typography
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  lineHeight: 2.25,
                  color: "#C8017D",
                }}
                variant="subtitle1"
              >
                {t("actionButtons.cancel")}
              </Mui.Typography>
            </Mui.Button>

            <Mui.Button
              sx={{
                maxWidth: "111px",
                maxHeight: "48px",
                minWidth: "111px",
                minHeight: "48px",
              }}
              variant="contained"
              color="accent"
              onClick={onClickDelete}
            >
              <Mui.Typography
                sx={{
                  textTransform: "capitalize",
                  fontWeight: 700,
                  lineHeight: 2.25,
                  color: "white",
                }}
                variant="subtitle1"
              >
                {t("actionButtons.confirm")}
              </Mui.Typography>
            </Mui.Button>
          </Mui.Stack>
        </Mui.DialogActions>
      </Mui.Dialog>
    </Mui.Box>
  );
};
